import { merge } from 'lodash';
import { AreaChart } from 'react-chartkick';

import { formatNumberWithSuffix } from '~/lib/formatters';

import ChangeArrow from './changeArrow.svg';
import DownArrow from './downArrow.svg';
import chartOptions, { downwardGraphOptions } from './highchartOptions';

const PageviewGraph = ({ data = [], className }) => {
  if (data.length === 0) return null;

  const last = data[data.length - 1]?.total || 0;
  const penultimate = data[data.length - 2]?.total || 0;

  const totalChange = last - penultimate;
  const noChange = totalChange == 0;
  const up = last >= penultimate;

  const library = up
    ? chartOptions
    : merge({}, chartOptions, downwardGraphOptions);
  const percentageChange =
    parseInt(Math.round(Math.abs(totalChange / penultimate) * 100, 0)) || 0;

  const labelForGraph = noChange ? (
    'No change'
  ) : (
    <>
      {percentageChange === 0
        ? formatNumberWithSuffix(totalChange)
        : `${formatNumberWithSuffix(percentageChange)}%`}

      {up ? (
        <ChangeArrow className="inline ml-1 -mb-1" />
      ) : (
        <DownArrow className="inline ml-1 -mb-1" />
      )}
    </>
  );

  return (
    <div
      className={classnames(
        'ck-box w-8/12 overflow-hidden p-0 relative',
        className,
      )}
      style={{ height: 120 }}>
      <div className="w-full h-full m-0 ml-auto">
        <AreaChart
          height="100%"
          colors={[up ? '#4EDC9F' : '#637eff']}
          data={data.reduce((acc, datum) => {
            const { date, total } = datum;
            acc[date] = total;
            return acc;
          }, {})}
          library={library}
        />
      </div>
      <div
        className="absolute flex flex-col w-10/12 h-full p-4"
        style={{
          background: 'linear-gradient(90deg, white, rgba(255, 255, 255, 0)',
        }}>
        <span className="mb-auto text-gray-500">Recent pageviews</span>
        <span
          className={classnames('text-xl font-bold align-baseline', {
            'text-green-500': up && !noChange,
            'text-indigo-500': !up && !noChange,
            'text-gray-400': noChange,
          })}
          style={{ fontSize: 32, lineHeight: 1 }}>
          {labelForGraph}
        </span>
        <span className="text-gray-600">
          {noChange ? 'No change' : up ? 'Up' : 'Down'} this week
        </span>
      </div>
    </div>
  );
};

PageviewGraph.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      total: PropTypes.number,
      date: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
};

export default PageviewGraph;
